export const raw = {
    "bsc": "Before School Care",
    "asc": "After School Care",
    "vac": "Vacation Care",
    "enrolNewChild": "Enrol New Child",
    "updateBookingSchedule": "Update Schedule",
    "enrol": "Enrol",
    "permissionSlip": "Permission Slip"
}